import React from 'react';
import logo from './logo.svg';
import './App.css';
import WordAnalyzer from "./components/WordAnalyzer";

function App() {
  return (
    <div className="App">
      <WordAnalyzer />
    </div>
  );
}

export default App;
